<ng-container *ngIf="note; else selectNote">
  <!-- Header -->
  <div class="header">
    <!-- Toolbar -->
    <div class="toolbar">
      <div class="info">
        <!-- Subject -->
        <div class="subject">{{ note.title }}</div>
      </div>

      <div class="mr-4">
        <!-- Other actions button & menu -->
        <button
          mat-icon-button
          (click)="changeEventPanelMode('view')"
          *ngIf="panelMode === 'edit'"
          type="button"
          [appAuthorize]="getEditPermission()"
        >
          <mat-icon [svgIcon]="'cancel'"></mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="changeEventPanelMode('edit')"
          *ngIf="panelMode === 'view'"
          type="button"
          [appAuthorize]="getEditPermission()"
        >
          <mat-icon [svgIcon]="'create'"></mat-icon>
        </button>
        <button mat-icon-button (click)="deleteNote()" type="button" [appAuthorize]="getEditPermission()">
          <mat-icon [svgIcon]="'delete'"></mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Threads -->
  <div class="threads">
    <!-- Thread -->
    <div class="thread">
      <!-- Thread header -->
      <div class="header">
        <!-- Sender avatar -->
        <div class="avatar">
          <img [src]="note.user?.avatar_url" />
        </div>

        <!-- From -->
        <div class="from" (click)="changeEventPanelMode('edit')">{{ note.user_name }}</div>
      </div>

      <ng-container *ngIf="panelMode === 'view'">
        <!-- Associated Contacts -->
        <ng-container *ngIf="selectedUsers?.length > 0">
          <div class="header">
            <mat-icon [svgIcon]="'people'"></mat-icon>
            <div class="contacts-list-container">
              <mat-chip-list aria-label="user selection">
                <mat-chip *ngFor="let user of selectedUsers">{{ user.name }}</mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </ng-container>
        <!-- Content -->
        <div class="content" (click)="changeEventPanelMode('edit')">
          <quill-view-html
            [content]="mentionsService.formatMessage(note.body)"
            sanitize
            theme="snow"
            class="w-full"
          ></quill-view-html>
        </div>
      </ng-container>

      <ng-container *ngIf="panelMode === 'add' || panelMode === 'edit'">
        <div class="panel-mode-edit">
          <form [formGroup]="noteForm">
            <!-- Title -->
            <div class="row title">
              <mat-icon [svgIcon]="'edit'"></mat-icon>

              <mat-form-field class="field treo-mat-no-subscript">
                <input matInput [formControlName]="'title'" [placeholder]="'Event title'" data-cy="note-title" />
              </mat-form-field>
            </div>

            <div class="row contacts">
              <mat-icon [svgIcon]="'people'"></mat-icon>
              <mat-form-field class="field treo-mat-no-subscript">
                <mat-chip-list #chipList aria-label="User selection" class="mat-chip-list">
                  <mat-chip *ngFor="let user of selectedUsers" selectable removable (removed)="removeUser(user)">
                    {{ user.name }}
                    <mat-icon matChipRemove class="m-0">cancel</mat-icon>
                  </mat-chip>
                  <input
                    placeholder="Add Contacts..."
                    #userInput
                    [formControl]="userCtrl"
                    [matAutocomplete]="auto"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    data-cy="note-contacts"
                  />
                </mat-chip-list>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedUser($event)">
                  <mat-option *ngFor="let user of contactList" [value]="user.name" [id]="user.id">
                    {{ user.name }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>

            <!-- Description -->
            <div class="row description">
              <mat-icon [svgIcon]="'notes'"></mat-icon>

              <quill-editor
                [formControlName]="'body'"
                [modules]="quillModules"
                [mentionConfig]="mentionConfig"
                (onEditorCreated)="onEditorCreated($event)"
                data-cy="note-body-text"
              ></quill-editor>
            </div>
            <div class="reply-form-buttons">
              <button mat-flat-button type="button" (click)="changeEventPanelMode('view')">
                <span>Cancel</span>
              </button>
              <!-- Actions -->
              <button mat-flat-button type="submit" [color]="'primary'" (click)="updateNote()" data-cy="save-note">
                Save
              </button>
            </div>
          </form>
        </div>
      </ng-container>

      <!-- Buttons -->
      <div class="buttons" *ngIf="replyFormActive">
        <!-- Reply -->
        <button mat-stroked-button type="submit" [color]="'primary'" (click)="reply()">
          <mat-icon [svgIcon]="'reply'"></mat-icon>
          <span>Add Comment</span>
        </button>
      </div>

      <!-- Reply form -->
      <div class="reply-form" *ngIf="replyFormActive" #replyForm>
        <mat-form-field class="treo-mat-textarea treo-mat-no-subscript">
          <textarea class="textarea" matInput [placeholder]="'Type your reply here'" [rows]="4"></textarea>
        </mat-form-field>

        <div class="actions">
          <div class="formatting">
            <!-- Attach file -->
            <button mat-icon-button type="button">
              <mat-icon [svgIcon]="'attach_file'"></mat-icon>
            </button>

            <!-- Insert link -->
            <button mat-icon-button type="button">
              <mat-icon [svgIcon]="'link'"></mat-icon>
            </button>

            <!-- Insert emoji -->
            <button mat-icon-button type="button">
              <mat-icon [svgIcon]="'insert_emoticon'"></mat-icon>
            </button>

            <!-- Insert image -->
            <button mat-icon-button type="button">
              <mat-icon [svgIcon]="'image'"></mat-icon>
            </button>
          </div>

          <div class="reply-form-buttons">
            <!-- Discard -->
            <button mat-flat-button type="button" (click)="discard()">
              <span>Discard</span>
            </button>

            <!-- Send -->
            <button
              class="send-button"
              type="submit"
              mat-raised-button
              [color]="'primary'"
              (click)="send()"
              [appAuthorize]="getEditPermission()"
              denyAction="disable"
            >
              <span>Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- Select mail to read template -->
<ng-template #selectNote>
  <div class="select-mail-to-read">
    <mat-icon [svgIcon]="'iconsmind:mailbox_empty'"></mat-icon>
    <h4>Select a note to read</h4>
  </div>
</ng-template>
